import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./EnumResources.da.resx"
import { R as _en } from "./EnumResources.en.resx"

type Translations = {
	"Name1": string,
	"Bitmap1": string,
	"Icon1": string,
	"CaregiverRoleEnum_Doctor": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

		return name
	},
}) as Translations

export { R }